import {
  CulqiCheckoutOptions,
  loadCulqiCheckout,
} from "@/hooks/use-culqi-checkout";
import { useEffect, useId, useRef } from "react";

type PaymentFieldsProps = {
  className?: string;
  onComplete: (token: string) => void;
  onError?: (error: Error) => void;
};

export default function PaymentFields({
  publicKey,
  amountCents,
  currency,
  title,
  email,
  description,
  className,
  onComplete,
  onError,
}: CulqiCheckoutOptions & PaymentFieldsProps) {
  const containerId = useId();
  const containerRef = useRef(null);
  const didMountRef = useRef(false);
  const checkoutRef = useRef<InstanceType<
    NonNullable<Window["CulqiCheckout"]>
  > | null>(null);

  async function renderCulqiCheckout() {
    const checkout = await loadCulqiCheckout({
      publicKey,
      amountCents,
      currency,
      title,
      email,
      description,
      container: `#${containerId}`,
      modal: false,
      hiddenBanner: true,
      hiddenCulqiLogo: true,
      onComplete,
      onError,
    });
    checkout.open();
    checkoutRef.current = checkout;
    didMountRef.current = true;
  }

  useEffect(() => {
    if (containerRef.current && !didMountRef.current) {
      renderCulqiCheckout();
    }
  }, []);

  useEffect(() => {
    const checkout = checkoutRef.current;
    if (checkout) {
      checkout.culqi = function () {
        if (checkout.token) {
          onComplete(checkout.token.id);
        } else if (checkout.error) {
          onError?.(
            new Error(checkout.error.user_message || "Culqi checkout error")
          );
        } else {
          onError?.(
            new Error("Culqi checkout closed without completing payment")
          );
        }
      };
    }
  }, [onComplete, onError]);

  return <div id={containerId} ref={containerRef} className={className} />;
}
